<template>
	<div id="buildingLeftBottom">
		<dv-border-box-6>
			<div class="d-flex pt-2 pl-2">
				<div class="d-flex">
					<span class="mt-3 ml-3 title_t">运行监控</span>
				</div>
			</div>
			<div class="d-flex" style="height: 80%;">
				<div class="text d-flex flex-column jc-around" style="width: 26%;margin-left: 0.4rem;">
					<div>
						<p>运行数量<br><span
								style="color: #2FDD92;font-weight: bold;">{{ chartData.running_count }}</span>/个</p>
						<p class="mt-4">配置数量<br><span
								style="color: #F76E11;font-weight: bold;">{{ chartData.devices_count }}</span>/台</p>
						<p class="mt-4">设备在线率<span style="color: #18FEFE;">{{ onlineData }}%</span></p>
					</div>
				</div>
				<div class="text" style="width: 35%;">
					<dv-water-level-pond :config="config" style="width:1.875rem;height:1.875rem;margin: 0.3rem auto;" />
					<p class="mt-1 text-center">当前负载率</p>
				</div>
				<div class="text d-flex flex-column jc-center ml-5" style="width: 25%;">
					<div>
						<p>当前告警<br><span class="mt-5"
								style="color: #F76E11;font-weight: bold;">{{ chartData.fault_count }}</span>/台</p>
					</div>
				</div>
			</div>
		</dv-border-box-6>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				config: {
					data: [],
					shape: 'round',
					waveNum: 2,
					waveHeight: 10,
					waveOpacity: 0.5,
					colors: ['#00BAFF', '#3DE7C9']
				},
				chartData: {
					devices_count: 0,
					online_count: 0,
					running_count: 0,
					cooling_power_count: 0,
					max_cooling_power: 0,
					fault_count: 0
				},
				onlineData: 0,
			};
		},
		components: {

		},
		props: ['building'],
		watch: {
			'building': {
				handler() {
					this.devicesOverview();
				},
			}
		},
		mounted() {
			this.devicesOverview()
		},
		methods: {
			async devicesOverview() {
				let dataObj = {
					building_id: this.building,
				}
				await this.$axios.get("/api/buildings/devicesOverview", {
					params: dataObj
				}).then(res => {
					this.onlineData = (res.data.data.online_count/res.data.data.devices_count*100).toFixed(0)
					let loadData = 0
					loadData = (res.data.data.cooling_power_count/res.data.data.max_cooling_power*100).toFixed(0)
					this.config= {
						data: [loadData],
						shape: 'round',
						waveNum: 2,
						waveHeight: 10,
						waveOpacity: 0.5,
						colors: ['#00BAFF', '#3DE7C9']
					},
					this.chartData = res.data.data
				})
			},
		},
	};
</script>

<style lang="scss">
	#buildingLeftBottom {
		height: 3.65rem;
		width: 6.45rem;

		.dv-water-pond-level canvas {
			margin-left: 8px !important;
		}

		.text {
			// text-align: center;

			p {
				font-size: 0.1875rem;
				color: white;
				line-height: 0.3125rem;
			}

			span {
				display: inline-block;
				width: 0.625rem;
				font-size: 0.275rem;
			}
		}
	}
</style>
